import { getVote } from "@/lib/voteStore";

// After this many guest votes, the next NEW vote is walled behind sign-up.
export const WALL_THRESHOLD = 3;
const KEY = "fv_guest_voted";

function read() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}

export function guestVoteCount() {
  return read().length;
}

export function recordGuestVote(topicId) {
  const list = read();
  if (!list.includes(topicId)) {
    list.push(topicId);
    localStorage.setItem(KEY, JSON.stringify(list));
  }
  return list.length;
}

// A guest voting on a NEW debate once the threshold is hit must sign up first.
// Re-voting on a debate they already voted on stays allowed.
export function guestWallReached(topicId) {
  return guestVoteCount() >= WALL_THRESHOLD && !getVote(topicId);
}

export function clearGuestVotes() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}

// Staged nudges: subtle on vote 1, firmer on 2, "last free" on 3.
export function guestNudge(count) {
  if (count >= WALL_THRESHOLD) return { msg: "That's your last free vote — sign up to keep voting & save your streak.", action: true };
  if (count === 2) return { msg: "You're on a roll 🔥 Sign up to save your streak & join the debate.", action: true };
  return { msg: "Nice pick! Sign in anytime to save your streak.", action: false };
}

export function openAuth() {
  window.dispatchEvent(new CustomEvent("fv-open-auth"));
}

export function openAuthWall() {
  window.dispatchEvent(new CustomEvent("fv-open-auth", { detail: { reason: "wall" } }));
}
